import React, { Component } from "react";
import { connect } from "react-redux";
import { selectors as accountsSelectors } from "reducers/accounts";
import { bool, shape } from "prop-types";

import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import ProductList from "pages/_components/product/List";
import { isIOS, isMobile } from "react-device-detect";
import AgreementItem from "./AgreementItem";

class AgreementsList extends Component {
    static propTypes = {
        agreements: shape({}).isRequired,
        firstFetched: bool.isRequired,
        isDesktop: bool.isRequired,
        isFetchingAgreements: bool.isRequired,
        moreAgreements: bool.isRequired,
    };

    state = {
        columns: this.props.isDesktop ? 6 : 2,
        rows: this.props.isDesktop ? 1 : 3,
    };

    renderItem = (agreement) => {
        const { isDesktop } = this.props;
        const { columns, rows } = this.state;

        return (
            <GridTable.Container className="box" columns={columns} rows={rows}>
                <AgreementItem isDesktop={isDesktop} agreement={agreement} />
            </GridTable.Container>
        );
    };

    renderList = (list, renderLoadMore) => {
        const { isDesktop } = this.props;
        const isEmpty = list.length === 0;
        const { columns, rows } = this.state;

        return (
            <>
                <GridTable
                    className={
                        isIOS || isMobile
                            ? "scrollable section-accounts agreements-table underlined pb-9"
                            : "scrollable section-accounts agreements-table underlined"
                    }>
                    {isDesktop && (
                        <GridTable.Header>
                            <GridTable.Container key="AgreementsList" columns={columns} rows={rows}>
                                <GridTable.Data columnStart={1} rowStart={1}>
                                    <I18n id="tableHeader.number" />
                                </GridTable.Data>
                                <GridTable.Data columnStart={2} rowStart={isDesktop ? 1 : 2}>
                                    <I18n id="tableHeader.creationDate" />
                                </GridTable.Data>
                                <GridTable.Data columnStart={3} rowStart={isDesktop ? 1 : 3}>
                                    <I18n id="tableHeader.expiracyDate" />
                                </GridTable.Data>
                                <GridTable.Data columnStart={4} rowStart={1}>
                                    <I18n id="tableHeader.tna" />
                                </GridTable.Data>
                                <GridTable.Data columnStart={5} rowStart={1} alignX="right">
                                    <I18n id="tableHeader.agreement" />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable.Header>
                    )}
                    <GridTable.Body>{list}</GridTable.Body>
                </GridTable>
                {!isEmpty && renderLoadMore()}
            </>
        );
    };

    render() {
        const { agreements, firstFetched, isFetchingAgreements, moreAgreements } = this.props;

        return (
            <>
                <ProductList
                    fetching={isFetchingAgreements}
                    items={agreements}
                    renderItem={this.renderItem}
                    lastPage={!moreAgreements}
                    onLoadMoreClick={this.handleClick}
                    firstFetched={firstFetched}
                    noMoreDataText=""
                    loadMoreText=""
                    noDataText="global.no.results"
                    noFiltersDataText="accounts.agreement.request.notification">
                    {this.renderList}
                </ProductList>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    account: accountsSelectors.getSelectedAccount(state),
    agreements: accountsSelectors.getAgreements(state),
    fetching: accountsSelectors.getFetching(state),
});

export default connect(mapStateToProps)(AgreementsList);
